import toArray from '../../general/toArray';

import * as exUtils from './utils';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        isVisibleElement(): boolean;
        empty(): HTMLElement;
        showElement(display?: string): HTMLElement;
        hideElement(): HTMLElement;
        toggleElement(value?: boolean): boolean;
    }
    interface NodeList {
        empty(): NodeList;
        showElement(display?: string): NodeList;
        hideElement(): NodeList;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.isVisibleElement = function (): boolean {
    return exUtils.isVisible(this);
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.empty = function (): HTMLElement {
    exUtils.empty(this);

    return this;
};

NodeList.prototype.empty = function (): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            exUtils.empty(element);
        }
    }

    return this;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.showElement = function (display?: string): HTMLElement {
    exUtils.show(this, display);

    return this;
};

NodeList.prototype.showElement = function (display?: string): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            exUtils.show(element, display);
        }
    }

    return this;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.hideElement = function (): HTMLElement {
    exUtils.hide(this);

    return this;
};

NodeList.prototype.hideElement = function (): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            exUtils.hide(element);
        }
    }

    return this;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.toggleElement = function (value?: boolean): boolean {
    return exUtils.toggle(this, value);
};
